import { createRouter, createWebHistory } from "vue-router";
import Subscription from "./components/Subscription.vue";
import AdminLogPage from "./pages/AdminLogPage.vue";
// import CalChat from "./components/calendar/CalChat.vue";
// import CalVoice from "./components/calendar/CalVoice.vue";
// import AnswerPlayground from "./pages/AnswerPlayground.vue";
// import ScrapePlayground from "./pages/ScrapePlayground.vue";
// import ResearchPlayground from "./pages/ResearchPlayground.vue";
// import SearchPlayground from "./pages/SearchPlayground.vue";

// const DbTestPage = () => import("./components/TestPages/DbTestPage.vue");
// const UsagePage = () => import("./pages/UsagePage.vue");
// const CalVoice = () => import("./components/calendar/CalVoice.vue");
const SchedulePage = () => import("./pages/SchedulePage.vue");
const ManageApiKeys = () => import("./components/ManageApiKeys.vue");
// const SignUp = () => import("./pages/SignUp.vue");
const Log = () => import("./pages/LogPage.vue");
// const ResearchPlayground = () => import("./pages/ResearchPlayground.vue");
// const ScrapePlayground = () => import("./pages/ScrapePlayground.vue");
// const SearchPlayground = () => import("./pages/SearchPlayground.vue");
// const AnswerPlayground = () => import("./pages/AnswerPlayground.vue");
// const ExtractPlayground = () => import("./pages/ExtractPlayground.vue");
// const Agents = () => import("./components/calendar/Agents.vue");
// const OAuthExchange = () => import("./components/calendar/OAuthExchange.vue");
// const Connections = () => import("./pages/Integrations.vue");
// const Workflow = () => import("./components/workflows/Workflow.vue");
// const WorkflowList = () => import("./components/workflows/WorkflowList.vue");
// const WorkflowAppPage = () => import("./components/workflows/WorkflowAppPage.vue");
// const Waitlist = () => import("./components/Waitlist.vue");
const ProjectList = () => import("./components/projects/ProjectList.vue");
const Requests = () => import("./components/projects/Requests.vue");
const RequestDetail = () => import("./components/projects/RequestDetail.vue");
const TableList = () => import("./components/tables/TableList.vue");
const TableView = () => import("./components/tables/TableView.vue");
const TableCreate = () => import("./components/tables/TableCreate.vue");

const routes = [
  // {
  //   path: "/executor",
  //   component: DbExecutorPage,
  //   name: "executor",
  // },
  {
    path: '/', redirect: '/new'
  },
  // {
  //   path: '/oauth/exchange',
  //   props: true,
  //   component: OAuthExchange,
  // },
  // {
  //   path: '/workflows',
    
  //   children: [
  //     {
  //       path: '',
  //       component: WorkflowList,
  //       name: 'workflows'
  //     },
  //     {
  //       path: ':id',
  //       component: Workflow,
  //       name: 'workflow',
  //       props: true
  //     }
  //   ]
  // },
  // {
  //   path: '/run/:id',
  //   component: WorkflowAppPage,
  //   props: true,
  //   name: 'run'
  // },
  // {
  //   path: '/integrations',
  //   component: Connections,
  //   name: 'integrations',
  // },
  // {
  //   path: '/agents',
  //   children: [
  //     {
  //       path: "",
  //       component: Agents,
  //       name: 'agents',
  //     },
  //     {
  //       path: ":id",
  //       component: CalVoice,
  //       name: 'voice',
  //       props: true,        
  //     }
  //   ]    
  // },
  // {
  //   path: '/agents',
  //   component: Agents,
  //   name: 'agents',
  // },
  // {
  //   path: "/we",
  //   component: CalVoice,
  //   name: 'voice',
  //   // props: true,        
  // },
  
  // {
  //   path: '/calendar',
  //   component: CalChat,
  //   name: 'calendar'
  // },
  // {
  //   path: '/voice',
  //   component: CalVoice,
  //   name: 'voice'
  // },
  // {
  //   path: '/research',
  //   component: ResearchPlayground,
  //   name: "research",
  // },
  // {
  //   path: '/answer',
  //   component: AnswerPlayground,
  //   name: 'answer'
  // },
  // {
  //   path: '/extract',
  //   component: ExtractPlayground,
  //   name: 'extract'
  // },
  // {
  //   path: '/scrape',
  //   component: ScrapePlayground,
  //   name: 'scrape'
  // },
  // {
  //   path: '/search',
  //   component: SearchPlayground,
  //   name: 'search'
  // },
  // {
  //   path: "/table/:id?",
  //   component: ExtractTable,
  //   name: "table",
  //   // alias: "/",
  //   params: { id: "id"},
  //   props: true,
  // },
  // {
  //   path: "/jobconfigs",
  //   name: "jobconfigsRoot",
  //   children: [
  //     {
  //       path: "",
  //       component: JobConfigs,
  //       name: "jobconfigs",
  //     },
  //     {
  //       path: ":id",
  //       component: DbExecutorPage,
  //       name: "jobconfig",
  //       props: true,
  //     },
  //   ],
  // }, 

  // {
  //   path: "/import",
  //   component: ImportData,
  //   name: "import",
  // },
  // {
  //   path: '/table/:name',
  //   component: IvyDbTable,
  //   name: "table",
  //   params: { name: 'name' }
  // },
  
  // {
  //   path: "/models/:id?",
  //   component: LLMProviders,
  //   name: "models",
  // },
  // {
  //   path: "/db",
  //   component: DbConnections,
  //   name: "dbConnections",
  // },
  {
    path: '/log', component: Log, name: 'log'
  },
  {
    path: '/adminlog', component: AdminLogPage, name: 'adminlog'
  },
  { path: "/manage", component: ManageApiKeys, name: "manage" },
  {
    path: "/subscription",
    component: Subscription,
    name: "subscription",
    props: true,
  },
  // { path: "/usage", component: UsagePage, name: "usage" },
  { path: "/schedule", component: SchedulePage, name: "schedule" },
  // { path: "/dbTestPage", component: DbTestPage },
  { path: "/signup", 
    // component: SignUp 
    // redirect: '/workflows'
    // component: WorkflowList
    redirect: '/waitlist'
  },

  { path: "/waitlist", component: TableList },
  {
    path: '/projects',
    children: [
      {
        path: '',
        component: ProjectList,
        name: 'projects'
      },
      {
        path: ':id/requests',
        component: Requests,
        name: 'project-requests',
        props: true
      },
      {
        path: ':projectId/requests/:requestId',
        component: RequestDetail,
        name: 'request-detail',
        props: true
      }
    ]
  },
  {
    path: '/tables',
    component: TableList,
    name: 'tables'
  },
  {
    path: '/new',
    component: TableCreate,
    name: 'new-table',
  },
  {
    path: '/tables/:id',
    component: TableView,
    name: 'table',
    props: true
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

export default router;
